const SESSION_TIMEOUT_HALF = 900,
  SESSION_TIMEOUT_END = 300,
  MAX_ATTEMPS_WARNING = 5;

export { MAX_ATTEMPS_WARNING, SESSION_TIMEOUT_END, SESSION_TIMEOUT_HALF };
